import { render, staticRenderFns } from "./FormRestored.vue?vue&type=template&id=e5e0f200&scoped=true"
import script from "./FormRestored.vue?vue&type=script&lang=js"
export * from "./FormRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e0f200",
  null
  
)

export default component.exports